import { firestore } from "../../config/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateCampaign = async (id, obj) => {
  const campaignRef = doc(firestore, "campaigns", id);
  await updateDoc(campaignRef, obj);
};

export default updateCampaign;